export const Types = {
  // Lista Módulos
  GET_DELETE_REQUEST: 'module/GET_DELETE_REQUEST',
  GET_DELETE_SUCCESS: 'module/GET_DELETE_SUCCESS',
  GET_DELETE_FAILURE: 'module/GET_DELETE_FAILURE',
};

export const initialState = {
  // Lista de Módulos
  moduleDeleteLoading: false,
  moduleDeleteError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Lista de Módulos
    case Types.GET_DELETE_REQUEST:
      return { ...state, moduleDeleteLoading: true };
    case Types.GET_DELETE_SUCCESS:
      return {
        moduleDeleteLoading: false,
        moduleDeleteError: null,
      };
    case Types.GET_DELETE_FAILURE:
      return {
        moduleDeleteLoading: false,
        moduleDeleteError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Busca lista de Módulo
  getModuleDeleteRequest: id => ({
    type: Types.GET_DELETE_REQUEST,
    payload: { id },
  }),
  getModuleDeleteSuccess: () => ({
    type: Types.GET_DELETE_SUCCESS,
  }),
  getModuleDeleteFailure: error => ({
    type: Types.GET_DELETE_FAILURE,
    payload: error,
  }),
};